// @flow

// Types
import type {
  ImportJobsToolOperationsById,
} from 'hfty-operator-import-jobs-tool/types'

// Constants
import {
  TREE,
  BRANCH,
} from 'hfty-model-import-jobs-tool'

// Utils
import traverse from 'fc-utils/traverse'

type ImportJobsOperationsSelector = (state: Object) => ImportJobsToolOperationsById

export default (traverse([TREE, BRANCH]): ImportJobsOperationsSelector)
